import { Translate } from '../../shared/LanguageService';
import { ButtonToolbar, Button } from 'react-bootstrap';
import * as React from 'react';

interface IProps {
    reset: () => void;
    save: () => void;
    canSave: boolean;
    isSaving: boolean;
}

const PlanAnnotationSaveReset = (props: IProps) => {
    return (
        <ButtonToolbar className="button-row">
            <Button bsStyle="danger" onClick={props.reset}>
                {Translate('plans/annotation/header/button-labels/reset')}
            </Button>
            <Button
                bsStyle="success"
                onClick={props.save}
                disabled={!props.canSave || props.isSaving}
            >
                {props.isSaving && <i className="load-spin-light"></i>}{' '}
                {Translate('plans/annotation/header/button-labels/save')}
            </Button>
        </ButtonToolbar>
    );
};

export default PlanAnnotationSaveReset;
